import classNames from 'classnames';
import { useMemo, useState } from 'react';

interface TabButtonProps {
  className?: string;
  children: JSX.Element[];
}

const TabButton: React.FC<TabButtonProps> = ({ children, className }) => {
  const [active, setIsActive] = useState(0);

  const mappedChidlren = useMemo(
    () =>
      children.map((child, index) => (
        <div
          // eslint-disable-next-line
          key={index}
          className={`trojan-tab-button-wrapper ${active === index ? 'active' : ''}`}
          onClick={() => setIsActive(index)}
        >
          {child}
        </div>
      )),
    [children, active]
  );

  return (
    <div className={classNames('trojan-tab-button', className)}>
      {mappedChidlren}
    </div>
  );
};

export default TabButton;
